var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_outline_user-tick",
    "data-name": "vuesax/outline/user-tick",
    transform: "translate(-300 -188)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "user-tick",
    transform: "translate(300 188)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.188,14.375a7.188,7.188,0,1,1,7.188-7.187A7.2,7.2,0,0,1,7.188,14.375Zm0-12.5A5.313,5.313,0,1,0,12.5,7.188,5.324,5.324,0,0,0,7.188,1.875Z",
    transform: "translate(7.813 1.563)",
    fill: "#292d32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M.938,10.625A.944.944,0,0,1,0,9.688C0,4.35,5.237,0,11.675,0a13.618,13.618,0,0,1,3.7.5.934.934,0,1,1-.5,1.8,11.834,11.834,0,0,0-3.2-.425c-5.4,0-9.8,3.5-9.8,7.813A.944.944,0,0,1,.938,10.625Z",
    transform: "translate(3.325 17.813)",
    fill: "#292d32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M5.938,11.875A5.9,5.9,0,0,1,.863,8.988,5.765,5.765,0,0,1,0,5.938,5.89,5.89,0,0,1,2.225,1.3a5.941,5.941,0,0,1,9.65,4.638A5.84,5.84,0,0,1,11.012,9a5.524,5.524,0,0,1-1.188,1.4A5.741,5.741,0,0,1,5.938,11.875Zm0-10A4.082,4.082,0,0,0,1.875,5.938a3.961,3.961,0,0,0,.588,2.087A4.054,4.054,0,0,0,5.938,10,3.99,3.99,0,0,0,8.6,8.988a3.6,3.6,0,0,0,.8-.95,3.936,3.936,0,0,0,.6-2.1A4.07,4.07,0,0,0,5.938,1.875Z",
    transform: "translate(16.563 16.563)",
    fill: "#292d32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M2.172,4.335a.927.927,0,0,1-.662-.275L.272,2.823A.937.937,0,1,1,1.6,1.5l.6.6,2-1.85A.938.938,0,0,1,5.472,1.623L2.809,4.085A.978.978,0,0,1,2.172,4.335Z",
    transform: "translate(19.615 20.34)",
    fill: "#292d32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M0,0H30V30H0Z",
    fill: "none",
    opacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser2);
export default __webpack_public_path__ + "static/media/user2.301ca9378e2b25128a77623202feda02.svg";
export { ForwardRef as ReactComponent };